<div
  class=" flex flex-col  w-full h-full bg-[#151A20]"
>
 
    <div class="flex  mt-10 cursor-pointer" (appClickableDirective)="goBack()">
      <img
        class="ml-10"
        src="../../../../assets/images/customer_screens/back arrow.svg"
        alt="Back"
      />
      <span class="text-white ml-4">Back</span>
    </div>
    <div class="flex flex-col items-center pt-5 w-full h-full">
      <div
        class=" flex flex-col flex-grow w-full justify-evenly items-center mb-10"
      >
        <div class="flex flex-col justify-center">
          <img
            [src]="profileImage"
            alt="Avator"
            class="h-28 w-28 rounded-full"
            (appClickableDirective)="
              userData && userData.user_image ? previewImage(userData.user_image) : null
            "
          />
          <div class="flex flex-row space-x-2 my-2 justify-center items-center">
            <span class="text-white text-[15px]">{{
              displayName
            }}</span>
            <img
              src="../../../../assets/svg/upload-fota.svg"
              alt="Upload"
              class="hidden"
            />
          </div>
        </div>
        <div class="w-full flex flex-row justify-around">
          <div class="flex flex-row space-x-3">
            <img
              src="../../../../assets/svg/location_gray.svg"
              alt="User"
              class="w-12 h-12"
            />
            <div class="flex flex-col justify-center items-start">
              <span class="gradient-header text-[15px]">Name</span>
              <span class="text-white text-[15px] font-normal">{{
                displayName
              }}</span>
            </div>
          </div>
          <div class="flex flex-row space-x-3">
            <img
              src="../../../../assets/svg/phone_gray.svg"
              alt="Phone"
              class="w-12 h-12"
            />
            <div class="flex flex-col justify-center items-start">
              <span class="gradient-header text-[15px]">Mobile Number</span>
              <span class="text-white text-[15px] font-normal">{{ displayPhone }}</span>
            </div>
          </div>
          <div class="flex flex-row space-x-3">
            <img
              src="../../../../assets/svg/email_gray.svg"
              alt="Email"
              class="w-12 h-12"
            />
            <div class="flex flex-col justify-center items-start">
              <span class="gradient-header text-[15px]">E-mail</span>
              <span class="text-white text-[15px] font-normal">{{ displayEmail }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

